import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=588efa2a&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=588efa2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588efa2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588efa2a')) {
      api.createRecord('588efa2a', component.options)
    } else {
      api.reload('588efa2a', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=588efa2a&scoped=true&", function () {
      api.rerender('588efa2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aOg5mz6pGKOg/JS/comp/DateRange.vue"
export default component.exports